const trackEvent = function(category, action, label, value) {
  ga("send", "event", category, action, label, value)
}

export { trackEvent }